import React, {useState} from 'react';
import {Input, Button, Form, Dialog, Checkbox, Toast} from 'antd-mobile';
import axios from "axios";
import {paramsToFormData} from "../../utils/paramsToFormData";
import {useNavigate} from "react-router-dom";
import {LoadingContext} from "../../components/Loading/LoadingContext";
import ApiService, {serviceUrl} from "../../utils/ApiService";

const LoginPage = (props:any) => {
  const navigate = useNavigate()
  const { setIsLoading } = React.useContext(LoadingContext);
  const verImg=serviceUrl+"/api/login/captcha?";
  const {current:tempObj}=React.useRef<any>({codeUrl:verImg+Math.random()});
  const [_,upPage] = React.useState(Math.random());

  const onFinish = async (values: any) => {
    setIsLoading(true);
    window.localStorage.setItem("username",values.username)
    window.localStorage.setItem("password",values.password)
    const ret = await ApiService.login(values);
    setIsLoading(false);
    if(ret && ret.code==1){
      Toast.show("登录成功")
      window.localStorage.setItem('name',ret.data.name);
      window.localStorage.setItem('userid',ret.data.userid);
      navigate('/home/index');
    }else if(ret && ret.code == 9){
      Toast.show("验证码不正确")
      tempObj.codeUrl=verImg+Math.random();
      upPage(Math.random());
    }else if(ret){
      Toast.show(ret.message)
    }
  }
  React.useEffect(()=>{

  })

  return (
    <div style={{ background: "url("+require('./img/login.png')+")",backgroundSize: 'cover',backgroundPosition: 'center',position: 'absolute',top:0,left:0,right:0,bottom:0 ,display:"flex",alignItems:'center',justifyContent:'center'}}>

      <div style={{marginTop:'80px',width:'85%',height:'280px',background:'#fff',borderRadius:'25px',padding:'10px'}}>
        <Form
          onFinish={onFinish}
          initialValues={{
            username:window.localStorage.getItem("username"),
            password:window.localStorage.getItem("password")
          }}
          layout='horizontal'
          style={{'--prefix-width':'4em'}}
          footer={
            <Button block type='submit' color='primary' size='large'>
              提交
            </Button>
          }>

          <Form.Header>账号登录</Form.Header>
          <Form.Item name='username' label='账号' rules={[{ required: true }]}>
            <Input placeholder='请输入账号' />
          </Form.Item>
          <Form.Item name='password' label='密码' rules={[{ required: true }]}>
            <Input type="password" placeholder='请输入密码' />
          </Form.Item>
          <Form.Item name='authcode' label='验证码' rules={[{ required: true }]}
                     extra={
                       <div>
                         <img src={tempObj.codeUrl} style={{height:"40px"}}
                              onClick={()=>{
                                tempObj.codeUrl=verImg+Math.random();
                                upPage(Math.random());
                              }}
                         />
                       </div>
                     }>
            <Input placeholder='图形验证码' />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginPage;
